import { render, staticRenderFns } from "./LayoutHeader.vue?vue&type=template&id=54c47abe&scoped=true&"
var script = {}
import style0 from "./LayoutHeader.vue?vue&type=style&index=0&id=54c47abe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c47abe",
  null
  
)

export default component.exports